import React from 'react';
import { EditorClientConnector } from './EditorClientConnector';
import { EditorNotificationsEditorAndGame } from './EditorNotifications';
import { MapEditor } from '../mapEditor/MapEditor';
import { Route, Switch } from 'react-router-dom'; // Pages

import { routes } from '../../data/routes';
import { EditorGame } from '../game/EditorGame';
import { TileAssetEditor } from '../tileAssets/TileAssetEditor';
import { CombatConfigurator } from '../combat/CombatConfigurator';
import { ActionEditor } from '../action/ActionEditor';
import { AnimationEditor } from "../animations/AnimationEditor";
import { EditorPopupWindows } from './EditorPopupWindows';
import { observer } from 'mobx-react-lite';
import { Header } from './Header';
import { LoginForm } from '../auth/LoginForm';
import { localSettingsStore } from '../../stores/LocalSettingsStore';
import { userStore } from '../../stores/UserStore';
import { TranslationManagement } from '../translation/TranslationManagement';
import { editorStore } from '../../stores/EditorStore';
import { NavigateTo } from '../shared/NavigateTo';
export const Editor = observer(() => {
  if (!userStore.mayAccessEditor) return /*#__PURE__*/React.createElement(LoginForm, null);

  if (editorStore.startedInitialization && !editorStore.sessionModule && !userStore.mayOpenMainGameEditor) {
    if (userStore.mayUseWorkshopManagementView) {
      return /*#__PURE__*/React.createElement(NavigateTo, {
        to: routes.workshopManagement
      });
    } else {
      return /*#__PURE__*/React.createElement(LoginForm, null);
    }
  }

  const {
    isProductionEditor
  } = localSettingsStore;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditorClientConnector, null), /*#__PURE__*/React.createElement(EditorPopupWindows, null), /*#__PURE__*/React.createElement(EditorNotificationsEditorAndGame, null), /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Switch, null, isProductionEditor && /*#__PURE__*/React.createElement(Route, {
    path: routes.editorCombat,
    component: CombatConfigurator
  }), isProductionEditor && /*#__PURE__*/React.createElement(Route, {
    path: routes.editorTileAssets,
    component: TileAssetEditor
  }), isProductionEditor && /*#__PURE__*/React.createElement(Route, {
    path: routes.editorAnimations,
    component: AnimationEditor
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.editorMap,
    component: MapEditor
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.editorGame,
    component: EditorGame
  }), /*#__PURE__*/React.createElement(Route, {
    path: routes.translationManagement,
    component: TranslationManagement
  }), /*#__PURE__*/React.createElement(Route, null, /*#__PURE__*/React.createElement(ActionEditor, null))));
});